import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PerfilesUsuarioService } from 'src/app/servicios/perfiles-usuario.service';
import { SnackBarComponent } from 'src/app/snack-bar/snack-bar.component';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: true,
    imports: [MatIconModule,FormsModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class ChangePasswordComponent implements OnInit {

  @Output() cerrar = new EventEmitter<any>();
  @Output() cerrarUpdate = new EventEmitter<any>();

  @ViewChild('MSJConfirmaCancelarCHNGPW') private templateRefChangePass: TemplateRef<any>;
  @Input() public datos: any;
  modalRef: BsModalRef;
  durationInSeconds = 3;
  showPasswordPw = false;
  showPasswordREPw = false;
  contrasenia = "";
  REcontrasenia = "";
  showSpinner: boolean = false;

  // verificar contraseña
  regExPassword: RegExp = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,15}$/;
  passErrors: boolean = true;
  hasCapitalCase: RegExp = /[A-Z]/;
  hasLowerCase: RegExp = /[a-z]/;
  hasNumber: RegExp = /\d/;
  passLength: RegExp = /^\w{8,15}$/;
  errorCapitalCase: boolean = true;
  errorLowerCase: boolean = true;
  errorHasNumber: boolean = true;
  errorPassLength: boolean = true;
  errorPassNotMatch: boolean = true;
  showPassTooltip: boolean = false
  constructor(private svcUsuarios: PerfilesUsuarioService, private _snackBar: MatSnackBar, private modalService: BsModalService) { }

  ngOnInit(): void { }

  @ViewChild('changPassword') form: any

  ngAfterViewInit() {
    this.form.control.valueChanges
      .subscribe((inputs: any) => this.checkPassword(inputs));
  }

  checkPassword(inputs: any) {
    const passVerify = this.regExPassword.test(inputs.contrasenia)

    if (this.hasCapitalCase.test(inputs.contrasenia)) this.errorCapitalCase = false
    else this.errorCapitalCase = true
    if (this.hasLowerCase.test(inputs.contrasenia)) this.errorLowerCase = false
    else this.errorLowerCase = true
    if (this.hasNumber.test(inputs.contrasenia)) this.errorHasNumber = false
    else this.errorHasNumber = true
    if (this.passLength.test(inputs.contrasenia)) this.errorPassLength = false
    else this.errorPassLength = true
    if (inputs.contrasenia === inputs.REcontrasenia) this.errorPassNotMatch = false
    else this.errorPassNotMatch = true

    if (!this.errorCapitalCase && !this.errorLowerCase && !this.errorHasNumber
      && !this.errorPassLength && inputs.contrasenia === inputs.REcontrasenia && passVerify) {
      this.passErrors = false
    } else {
      this.passErrors = true
    }
  }
  // --

  toggleShowREPassword() {
    this.showPasswordREPw = !this.showPasswordREPw;
  }

  toggleShowPassword() {
    this.showPasswordPw = !this.showPasswordPw;
  }

  getInputTypePw() {
    if (this.showPasswordPw) {
      return 'text';
    }
    return 'password';
  }

  getInputTypeREPw() {
    if (this.showPasswordREPw) {
      return 'text';
    }
    return 'password';
  }

  getIconPw() {
    if (this.showPasswordPw) {
      return 'visibility';
    }
    return 'visibility_off';
  }

  getIconREPw() {
    if (this.showPasswordREPw) {
      return 'visibility';
    }
    return 'visibility_off';
  }

  savePassword() {
    let dto = { username: this.datos.username, password: this.contrasenia }
    this.showSpinner = true;
    this.svcUsuarios.changePassword(dto).subscribe(data => {
      this.openSnackBar("Contraseña cambiada con éxito.");
      this.cerrarModalUpdate();
      this.showSpinner = false;
    })
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  saveChangePw() {
    this.modalRef = this.modalService.show(this.templateRefChangePass, { class: 'modal-lg' });
  }

  cerrarModal() {
    this.cerrar.emit("cerrar")
  }

  hideConfirm() {
    this.modalRef.hide();
    this.cerrarModal();
  }

  cerrarModalUpdate() {
    this.modalRef.hide();
    this.cerrarUpdate.emit("cerrarUpdate")
  }

}
